module.exports = __webpack_public_path__ + "img/bahai.f0141968.svg";